import {
  BirdviewTileKey,
  DashboardTileTone,
} from '../DashboardBirdview.constants'

import EmailIcon from '../../../icons/email.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import TaskIcon from '../../../icons/task.svg'

export const BirdviewOversightWidget = {
  Activities: 'activities',
  Attention: 'attention',
  Communication: 'communication',
  CriticalRequests: 'criticalRequests',
  DocFlows: 'docFlows',
  Greta: 'greta',
  Portfolio: 'portfolio',
  TeamLoad: 'teamLoad',
}

// TODO Add Greta's suggestions to the layout once their endpoint ships.
export const BIRDVIEW_OVERSIGHT_LAYOUT = {
  left: [
    BirdviewOversightWidget.Activities,
    BirdviewOversightWidget.Portfolio,
    BirdviewOversightWidget.CriticalRequests,
    BirdviewOversightWidget.Communication,
  ],
  right: [
    BirdviewOversightWidget.Attention,
    BirdviewOversightWidget.TeamLoad,
    BirdviewOversightWidget.DocFlows,
  ],
}

export const BIRDVIEW_OVERSIGHT_TILES = [
  {
    Icon: TaskIcon,
    key: BirdviewTileKey.Overdue,
    labelKey: 'DashboardBirdview.TileOverdueKey',
    tone: DashboardTileTone.Success,
  },
  {
    Icon: ServiceRequestIcon,
    key: BirdviewTileKey.Unassigned,
    labelKey: 'DashboardBirdview.TileUnassignedKey',
    tone: DashboardTileTone.Warning,
  },
  {
    Icon: ServiceRequestIcon,
    key: BirdviewTileKey.Backlog,
    labelKey: 'DashboardBirdview.TileBacklogKey',
    tone: DashboardTileTone.Info,
  },
  {
    Icon: EmailIcon,
    key: BirdviewTileKey.Unread,
    labelKey: 'DashboardBirdview.TileUnreadKey',
    tone: DashboardTileTone.Purple,
  },
]
